/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	
	// preload
	
	(0, _module.preload)();
	
	// resizing
	
	(0, _module.resizing)();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	(0, _module.pageTop)();
	
	(0, _module.faqToggle)();
	
	(0, _module.formCheck)();
	
	(0, _module.headerToggle)();
	
	(0, _module.headerScroll)();
	
	// const scrollAnimation = () => {
	//   let winScroll = $(window).scrollTop();
	//   let winHeight = $(window).height();
	//
	//   // SNS
	//   const $tgt = $('.fix-registration');
	//   const $tgt2 = $('.fix-sns-btn');
	//   let mainvisualHeight = $('.mainvisual').height();
	//   let registrationNowPosition = $('.registration-now').offset().top;
	//   if (winScroll > mainvisualHeight && winScroll < registrationNowPosition - winHeight) {
	//     $tgt.addClass('is-fixed');
	//   } else {
	//     $tgt.removeClass('is-fixed');
	//   }
	//   if (winScroll > mainvisualHeight) {
	//     $tgt2.addClass('is-fixed');
	//   } else {
	//     $tgt2.removeClass('is-fixed');
	//   }
	// };
	$(window).on('scroll', function () {
	  // scrollAnimation();
	});
	
	$(window).on('load', function () {
	  // swiperslider();
	  setTimeout(function () {
	    // scrollAnimation();
	  }, 1800);
	});
	
	var controller = new ScrollMagic.Controller();
	var targets = document.querySelectorAll(".js-scrollAnimation");
	var targetsArray = Array.prototype.slice.call(targets); //Array
	targetsArray.forEach(function (target) {
	  //シーンを作成
	  var scene = new ScrollMagic.Scene({
	    triggerElement: target,
	    triggerHook: .9
	  }).setClassToggle(target, "is-animated").addTo(controller);
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 767;
	var heightChange = 50;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	// preload
	var preload = function preload() {
	  var timer = 0;
	  $(window).on('load', function () {
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      $("body").removeClass("preload");
	    }, 100);
	  });
	};
	
	// resizing
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    $('.header-menu').css('transition', 'none');
	    $('.header-menu a').css('transition', 'color .3s');
	    $('header .logo').css('transition', 'opacity .3s');
	    var resizeWidth = $window.width();
	    if (windowWidth !== resizeWidth) {
	      $("body").addClass("resizing");
	      if (timer > 0) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function () {
	        $("body").removeClass("resizing");
	      }, 100);
	    }
	    windowWidth = resizeWidth;
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	// ------------------------------------------------------------------------
	// headerScroll
	// ------------------------------------------------------------------------
	//headerScroll
	var headerScroll = function headerScroll() {
	  $(window).on('scroll', function () {
	    $('.header-menu a').css('transition', 'margin .3s,color .3s');
	    $('header .logo').css('transition', 'margin .3s,opacity .3s');
	    if ($(window).scrollTop() > heightChange) {
	      $('header').addClass('smaller');
	    } else if ($('header').hasClass('smaller')) {
	      $('header').removeClass('smaller');
	    }
	  });
	};
	
	// ------------------------------------------------------------------------
	// headerToggle
	// ------------------------------------------------------------------------
	//headerToggle
	var headerToggle = function headerToggle() {
	  $('header .hamburger,header .cross').on('click', function () {
	    //追加
	    $('.header-menu').css('transition', 'transform .3s');
	    //ここまで
	    $('.header-menu').toggleClass('opened');
	  });
	};
	// ------------------------------------------------------------------------
	// pageTop
	// ------------------------------------------------------------------------
	
	//ページTOP
	var pageTop = function pageTop() {
	
	  $(window).on("scroll", function () {
	    var scrollPosition = $(window).scrollTop();
	    // if(windowW >= 768){
	    if (scrollPosition >= 50) {
	      $(".sw-Top").removeClass('sw-Top-Hidden');
	    } else {
	      $(".sw-Top").addClass('sw-Top-Hidden');
	    }
	    // }
	  });
	
	  $("#st-Top,#footer-top").on("click", function () {
	    var linkSpeed = 500;
	    $("html, body").animate({ scrollTop: 0 }, linkSpeed, "easeOutQuint");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// faqToggle
	// ------------------------------------------------------------------------
	//faqToggle
	var faqToggle = function faqToggle() {
	  $('.faq_List .faq_List_Item dl dt').on('click', function () {
	    $(this).next('dd').slideToggle(250).css('display', 'block');
	    $(this).parent().toggleClass('opened');
	  });
	};
	// ------------------------------------------------------------------------
	// formCheck
	// ------------------------------------------------------------------------
	//formCheck
	var formCheck = function formCheck() {
	  $('#check').on('click', function () {
	    $(this).toggleClass('checked');
	    $('.send').toggleClass('ready');
	  });
	};
	
	//export
	exports.preload = preload;
	exports.resizing = resizing;
	exports.anchorScroll = anchorScroll;
	exports.pageTop = pageTop;
	exports.headerToggle = headerToggle;
	exports.faqToggle = faqToggle;
	exports.formCheck = formCheck;
	exports.headerScroll = headerScroll;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js